export class PasswordResetRequest {
  constructor(public userName: string) {}
}
